import { useParams } from "react-router-dom";

export const useParamsModelId = () => {
  const routeParams = useParams();
  return parseInt(routeParams.modelId ?? "0");
};
